import React from 'react';

const segments = [
  {
    title: 'Fashion Essentials',
    image: '/segments/fashion-essentials.png',
  },
  {
    title: 'Work Gadgets',
    image: '/segments/work-gadgets.png',
  },
  {
    title: 'Tech for Kids',
    image: '/segments/tech-for-kids.png',
  },
];

const CuratedSegments = () => {
  return (
    <section className="py-16 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-10">
          Curated Segments
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {segments.map((segment, index) => (
            <div key={index} className="relative rounded-xl overflow-hidden shadow-md hover:shadow-lg transition duration-300 group">
              <img
                src={segment.image}
                alt={segment.title}
                className="w-full h-56 object-cover transform group-hover:scale-105 transition duration-500"
              />
              <div className="absolute bottom-4 left-4 bg-white/80 backdrop-blur px-4 py-2 rounded">
                <h3 className="text-sm sm:text-base font-semibold text-gray-800">{segment.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CuratedSegments;
